<template>
  <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
  import { GoTop } from "@/utils/index"
  export default {
    name: "GoTop",
    data() {
      return {
        flag: false,
        lastRouteTo: "",
        lastRouteFrom: ""
      };
    },
    watch: {
      //$route(to, from) {
      //  console.log('$route(to, from) =============>', to, from)
      //  if (from.name == this.lastRouteTo.name) {
      //    return
      //  }
      //  if (to.name !== from.name) {
      //    setTimeout(() => {
      //      this.GoTop()

      //    },15)
      //  }
      //  this.lastRouteTo = to;
      //  this.lastRouteFrom = from;
      //}
    },
    methods: {
      GoTop() {
        GoTop();
      }
    }
  };
</script>
<style scoped>
  #GoTop {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 99999999;
    cursor: pointer;
  }

    #GoTop > span {
      display: block;
      width: 100%;
      height: 100%;
      color: rgb(8, 162, 233);
      font-size: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue